.autoReloadContainer {
  display: flex;
  padding: 9px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: var(--dark-3);
  border-radius: 4px;
  width: 100%;

  &.on {
    background: var(--green-10);

    .autoReloadButton {
      width: 30px;
    }
  }

  .text {
    flex-grow: 1;
  }

  .autoReloadButton {
    padding: 2px 3px;
  }
}
